export class QuantityService {

    constructor () {
        this._productsQuantity = {};
    }

    getQuantity (sku) {
        return this._skusQuantity[sku];
    }

    setQuantity (productId, quantity) {

        quantity = parseInt(quantity);

        this._productsQuantity[productId] = quantity;
        bus.$emit('product-quantity-changed', productId, quantity);
    }

}